class LoadMore extends HTMLElement {
  constructor() {
    super()
    this.url = this.getAttribute('url')
    this.source = document.querySelector(this.getAttribute('source-element'))
    this.target = this.getAttribute('target-element')
    this.actions = this.getAttribute('actions-element')
    this.button = this.querySelector('a')
    this.loadedElementsCount = this.source?.children.length
    this.loadCountElement = this.querySelector('.js-load-items-count')
  }

  connectedCallback() {
    this.loadCountElement.textContent = this.loadedElementsCount
    this._attachEvents()
  }

  _attachEvents() {
    if (this.button) {
      this.button.addEventListener('click', (event) => {
        event.preventDefault()
        this.fetchData()
      })
    }
  }

  fetchData() {
    fetch(this.url)
      .then((response) => {
        return response.text()
      })
      .then((html) => {
        const parser = new DOMParser()
        const parsedDocument = parser.parseFromString(html, 'text/html')
        const target = parsedDocument.querySelector(this.target)
        const sourceActions = document.querySelector(this.actions)
        const targetActions = parsedDocument.querySelector(this.actions)

        this.source.innerHTML += target.innerHTML
        this.loadedElementsCount = this.source.children.length
        this.loadCountElement.textContent = this.loadedElementsCount
        sourceActions.innerHTML = targetActions.innerHTML
      })
      .catch(function (err) {
        console.warn('Something went wrong.', err)
      })
  }
}

customElements.define('load-more', LoadMore)
